<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="this.$t('Station')" :label-width="60">
				<Select :placeholder="this.$t('Station')" style="width: 120px;" v-model="formInline.StationId">
					<Option :value=0>{{ this.$t('Common.All') }}</Option>
					<Option v-bind:key="item.StationId" v-for="(item) in StationList" :value="item.StationId">
						{{item.StationName}}
					</Option>
				</Select>
			</FormItem>
			<FormItem prop="trackName">
				<Input type="text" style="width: 180px;" v-model="formInline.OrderNo" placeholder="订单单号">
				<span slot="prepend">订单单号</span>
				</Input>
			</FormItem>
			
			<FormItem :label="$t('Common.Time')" :label-width='70'>
				<DatePicker style="width: 210px;" type="daterange" format="yyyy-MM-dd" placeholder="Select date"
					v-model="formInline.TimeRange" @on-change="handleChange"></DatePicker>
			</FormItem>
			
			<FormItem >
				<Input type="text" style="width: 150px;" v-model="formInline.MemberName" placeholder="会员名称">
				<span slot="prepend">会员名称</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 150px;" v-model="formInline.PhoneNo" placeholder="会员手机">
				<span slot="prepend">会员手机</span>
				</Input>
			</FormItem>
			<FormItem>
				<Input type="text" style="width: 150px;" v-model="formInline.ConnectorNo" placeholder="设备编号">
				<span slot="prepend">设备编号</span>
				</Input>
			</FormItem>
			<!-- <FormItem>
				<Input type="text" v-model="formInline.CouponName" placeholder="优惠活动">
				<span slot="prepend">优惠活动名称</span>
				</Input>
			</FormItem> -->
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">{{ $t('Common.Search') }}</Button>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="exportFile" v-if="hasWidgets('export')">{{ this.$t('ChargeRecord.ExportFile') }}</Button>
			</FormItem>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight" ref="ChargingOrder"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getChargeOrderUrl" @listData='getDeviceData'></MyPage>
		<!-- <echartModal ref="echartModal" curvesName="ChargeOrder"></echartModal> -->
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	// import echartModal from '../../public/CurvesTemplate/ChargingOrderEchart.vue'
	// import Qs from 'qs'
	// import expandRow from './ChargingOrderTemplate/ChargingOrderExpand.vue';
	import { formatLocalTime } from "../../../utils/date"

	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js';
	export default {
		// components: {
		// 	echartModal
		// },
		data() {
			return {
				getChargeOrderUrl: webapi.base_api_url + '/Order/GetChargePeriodDetail',
				loadingStatus: false,
				//
				params: "", //
				
				SelectStation: "",
				tableHeight: "650",
		
				BreadcrumbList: [this.$t('ordersRecord') , '>>',this.$t('chargePeriodDetail')],
				formInline: {
					StationId: 0,
					OrderNo: '',
					TimeBegin: dateFormat.formatDate(new Date(new Date().getTime() - 1000 * 60 * 60 * 24), 'yyyy-MM-dd'),
					TimeEnd: dateFormat.formatDate(new Date(), 'yyyy-MM-dd'),
					TimeRange: [new Date(new Date().getTime() - 1000 * 60 * 60 * 24), new Date()],
					MemberName: '',
					EquipmentNo: '',
					CouponName: '',
					PhoneNo: '',
					PaymentWay: 0,
				},
				//Table Title Data
				columns1: [
					{
						title: this.$t('ChargeRecord.OrderNo'),
						key: 'OrderNo',
						width: 180
					},
					{
						title: this.$t('ChargeRecord.ChargingStartTime'),
						key: 'ChargeStartTime',
						width: 110,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.ChargeStartTime))
						}
					},
					{
						title: this.$t('ChargeRecord.ChargingEndTime') ,
						key: 'ChargeEndTime',
						width: 110,
						render: (h, params) => {
							return h('div', formatLocalTime(params.row.ChargeEndTime))
						}
					},
					
					{
						title: this.$t('ChargeRecord.OrderStatus'),
						key: 'OrderStatus',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.OrderStatusDesc);
						}
					},
					{
						title: this.$t('ChargeRecord.MemberPhone'),
						key: 'MemberPhone',
						minWidth: 120,
					},
					{
						title: this.$t('ChargeRecord.MemberName') ,
						key: 'MemberName',
						minWidth: 100,
					},
					{
						title:this.$t('ChargeRecord.PrepaidAmount'),
						key: 'BalanceBefore',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.ChargeCost') ,
						key: 'ChargeCost',
						minWidth: 100,
					},
			
					{
						title: this.$t('ChargeRecord.ElecCost'),
						key: 'ChargeCostElec',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.ServiceCost') ,
						key: 'ChargeCostService',
						minWidth: 100,
					},
					// {
					// 	title: '结算金额(元)',
					// 	key: 'CouponCost',
					// 	minWidth: 100,
					// },
					{
						title: this.$t('ChargeRecord.SettlementType') ,
						key: 'SettleTypeDesc',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.SettleTypeDesc);
						}
					},
			
					{
						title: this.$t('ConnectorNo'),
						key: 'ConnectorNo',
						minWidth: 120,
					},
			
					{
						title:  this.$t('ChargeRecord.Period')+' 1 Kwh',
						key: 'Period1Kwh',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 2 Kwh',
						key: 'Period2Kwh',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 3 Kwh',
						key: 'Period3Kwh',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 4 Kwh',
						key: 'Period4Kwh',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 5 Kwh',
						key: 'Period5Kwh',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 6 Kwh',
						key: 'Period6Kwh',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 7 Kwh',
						key: 'Period7Kwh',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 8 Kwh',
						key: 'Period8Kwh',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 9 Kwh',
						key: 'Period9Kwh',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 10 Kwh',
						key: 'Period10Kwh',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 11 Kwh',
						key: 'Period11Kwh',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 12 Kwh',
						key: 'Period12Kwh',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 1 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period1ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 2 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period2ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 3 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period3ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 4 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period4ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 5 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period5ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 6 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period6ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 7 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period7ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 8 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period8ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 9 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period9ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 10 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period10ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 11 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period11ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 12 '+this.$t('ChargeRecord.ElecCost'),
						key: 'Period12ChargeFee',
						minWidth: 100,
					},
					{
						title: this.$t('ChargeRecord.Period')+' 1 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period1ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 2 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period2ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 3 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period3ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 4 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period4ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 5 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period5ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 6 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period6ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 7 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period7ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 8 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period8ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 9 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period9ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 10 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period10ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 11 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period11ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 12 '+this.$t('ChargeRecord.ServiceCost'),
						key: 'Period12ServiceFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 1 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period1TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 2 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period2TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 3 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period3TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 4 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period4TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 5 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period5TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 6 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period6TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 7 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period7TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 8 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period8TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 9 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period9TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 10 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period10TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 11 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period11TotalFee',
						minWidth: 100,
					},
					{
						title:  this.$t('ChargeRecord.Period')+' 12 '+this.$t('ChargeRecord.ChargeCost'),
						key: 'Period12TotalFee',
						minWidth: 100,
					},
				],
				data1: []
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					StationId: _this.formInline.StationId,
					OrderNo: _this.formInline.OrderNo,
					TimeBegin: _this.formInline.TimeBegin == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeBegin), 'yyyy-MM-dd'),
					TimeEnd: _this.formInline.TimeEnd == '' ? '' : dateFormat.formatDate(
						new Date(_this.formInline.TimeEnd), 'yyyy-MM-dd'),
					ConnectorNo: _this.formInline.ConnectorNo,
					MemberName: _this.formInline.MemberName,
					PhoneNo: _this.formInline.PhoneNo,
					// CouponName: _this.formInline.CouponName,
					// PaymentWay: _this.formInline.PaymentWay,
				}
				return param
			},
			
			...mapState({
				StationList: 'Stations'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			handleChange(date, type) {
				console.log("change date：", date, type);
				this.formInline.TimeBegin = date[0];
				this.formInline.TimeEnd = date[1];
			},
			exportFile: function() {
				this.$refs.ChargingOrder.exportCsv({
					filename: '充电时段明细',
					columns: this.columns1,
					data: this.data1.map(k => {
						k.OrderNo = "\t" + k.OrderNo;
						// k.OrderTime = '\t' + (k.OrderTime || '');
						k.ChargeStartTime = '\t' + (k.ChargeStartTime || '');
						k.ChargeEndTime = '\t' + (k.ChargeEndTime || '');
						// k.RefundTime = '\t' + (k.RefundTime || '');
						k.SettleTime = '\t' + (k.SettleTime || '');
						return k;
					})
				})
			},
			
			// show: function(type, params) {
			// 	const _this = this
			// 	switch (type) {
			// 		case "view":
			// 			_this.$refs.echartModal.show(type, params)
			// 			break;
			// 		default:
			// 			break;
			// 	}
			// },
			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},
			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
				// const _this = this;
				// let parms = _this.formInline;
				// _this.$axios.post(webapi.base_api_url + "/Order/GetChargeOrder", parms, {
				// }).then(res => {
				// 	console.log("res")
				// 	console.log(res.data)
				// 	if (res.data.Code == 0) {
				// 		_this.data1 = res.data.Data.AlarmingInfos;
				// 	}
				// })
			},

			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1528 ? 60 : 0);
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}
</style>
